
        import wasmModule from "/home/noahc42/micropad2/app/node_modules/fend-wasm/fend_wasm_bg.wasm";

        
        // Import from JS modules
        import { __wbindgen_object_drop_ref, __wbindgen_string_new, __wbg_now_44a034aa2e1d73dd, __wbg_newnoargs_9fdd8f3961dd1bee, __wbg_call_ba36642bd901572b, __wbg_getTime_55dfad3366aec58a, __wbg_getTimezoneOffset_baab8599eeb15f06, __wbg_new0_85024d5e91a046e9, __wbg_self_bb69a836a72ec6e9, __wbg_window_3304fc4b414c9693, __wbg_globalThis_e0d21cabc6630763, __wbg_global_8463719227271676, __wbindgen_is_undefined, __wbindgen_object_clone_ref, __wbg_get_800098c980b31ea2, __wbindgen_debug_string, __wbindgen_throw } from "./fend_wasm_bg.js";

        // Build the WASM import object
        const imports = {
            ["./fend_wasm_bg.js"]: {
                __wbindgen_object_drop_ref,
__wbindgen_string_new,
__wbg_now_44a034aa2e1d73dd,
__wbg_newnoargs_9fdd8f3961dd1bee,
__wbg_call_ba36642bd901572b,
__wbg_getTime_55dfad3366aec58a,
__wbg_getTimezoneOffset_baab8599eeb15f06,
__wbg_new0_85024d5e91a046e9,
__wbg_self_bb69a836a72ec6e9,
__wbg_window_3304fc4b414c9693,
__wbg_globalThis_e0d21cabc6630763,
__wbg_global_8463719227271676,
__wbindgen_is_undefined,
__wbindgen_object_clone_ref,
__wbg_get_800098c980b31ea2,
__wbindgen_debug_string,
__wbindgen_throw
            }
        };

        async function loadWasm(module, imports) {
            if (typeof module === 'string') {
                const moduleRequest = await fetch(module);
                if (typeof WebAssembly.instantiateStreaming === 'function') {
                    try {
                        return await WebAssembly.instantiateStreaming(moduleRequest, imports);
                    } catch (e) {
                        if (moduleRequest.headers.get('Content-Type') != 'application/wasm') {
                            console.warn(e);
                        } else {
                            throw e;
                        }
                    }
                }
                module = await moduleRequest.arrayBuffer();
            }
            return await WebAssembly.instantiate(module, imports);
        }

        export const { instance, module } = await loadWasm(wasmModule, imports);

        export const memory = instance.exports.memory;
export const initialise = instance.exports.initialise;
export const evaluateFendWithTimeout = instance.exports.evaluateFendWithTimeout;
export const evaluate_fend_with_timeout = instance.exports.evaluate_fend_with_timeout;
export const evaluateFendWithTimeoutMultiple = instance.exports.evaluateFendWithTimeoutMultiple;
export const __wbindgen_malloc = instance.exports.__wbindgen_malloc;
export const __wbindgen_realloc = instance.exports.__wbindgen_realloc;
export const __wbindgen_add_to_stack_pointer = instance.exports.__wbindgen_add_to_stack_pointer;
export const __wbindgen_free = instance.exports.__wbindgen_free;
export const __wbindgen_exn_store = instance.exports.__wbindgen_exn_store;
    